import { SoundManager } from '../../config/sound/SoundManager';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { Beheaded } from '../../Beheaded';
import { GameData } from '../../server/data/GameData';
import { BaseModel } from '../../server/base/BaseModel';
import { Presentation } from '../../../core/gameflow/controller/Presentation';
import { SplashController, SplashIndex } from '../../modules/splashScreen/SplashController';
import { BeheadedGameMode } from '../../server/data/BeheadedGameMode';

export class SFSIntroPresentation extends Presentation {


    // Only happens during a SFS bonus Buy. The rest will be handled after the Avalanche presentation.
    checkForActivation(data: GameData): boolean {
        return data.nextMode == BeheadedGameMode.SUPER_FREESPIN;
    }

    setGamedData(data: GameData): void {
        SplashController.instance.setData(SplashIndex.INTRO, data);
    }

    preStart(): void {}

    createPresentation(skip: Function): void {
        skip(false);
        if (Beheaded.counter.timeRemaining) {
            this.timeline.to(this, { duration: Beheaded.counter.timeRemaining });
            return;
        }

        SoundManager.fadeOutAmbient(100, 0);
        SlotGame.keypadPlugin.hide(1);
        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);

        this.timeline.add(SplashController.instance.play(SplashIndex.INTRO, true, true, () => {}));
        
        this.PresentationState.setInactive();
    }

    public done(): void {
        Beheaded.keypadPlugin.show();
    }
}
